import { render, staticRenderFns } from "./SideBarDropDown.vue?vue&type=template&id=704ac559&scoped=true"
import script from "./SideBarDropDown.vue?vue&type=script&lang=js"
export * from "./SideBarDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704ac559",
  null
  
)

export default component.exports